import React from 'react'
import { PrimaryBtn } from '../Button/button'
import Edit from '../../Assets/Images/edit.svg'
import Delete from '../../Assets/Images/delete.svg'
import { Link } from 'react-router-dom'
import { getBranding } from '../../utils/getBranding.js';

const BeneficiaryCard = ({Card = [], type}) => {
    const branding = getBranding();
  return (
    <>
    {Card.map((cards, index) => (
        <div key={index} className='w-full flex justify-between items-center p-4 rounded-md shadow-md bg-white'>
            <div className='text-[14px] font-[500] overflow-hidden'>
                <h1 className=' font-[800] text-[16px] mb-3' style={{ color: branding.color.primary }}>{type} - {cards.network}</h1>
                <p>NGN {cards.amount}</p>
                <p>{cards.beneficiaryPhone}</p>
                {/* <p>Added on 16 Nov, 2022</p> */}
            </div>
            <div className='ml-2 mt-8'>
                {/* <PrimaryBtn variant='contained' size='small' text='pay'/> */}
                {/* <div className='flex mt-4 justify-between'>
                    <Link>
                    <img src={Edit} alt="" />
                    </Link>
                    <Link>
                    <img src={Delete} alt="" />
                    </Link>
                </div> */}
            </div>
        </div>
    ))}
    </>
  )
}

export default BeneficiaryCard
